// Debug logger for tracking component renders and API calls
const DEBUG = process.env.NODE_ENV === 'development';

class DebugLogger {
  constructor() {
    this.renderCounts = {};
    this.apiCalls = {};
    this.lastResetTime = Date.now();
    
    // Reset counts every 30 seconds
    if (DEBUG) {
      setInterval(() => {
        const now = Date.now();
        const elapsed = now - this.lastResetTime;
        
        // Log summary
        this.logSummary();
        
        // Reset
        this.renderCounts = {};
        this.apiCalls = {};
        this.lastResetTime = now;
      }, 30000);
    }
  }
  
  trackRender(componentName) {
    if (!DEBUG) return;
    
    if (!this.renderCounts[componentName]) {
      this.renderCounts[componentName] = 0;
    }
    this.renderCounts[componentName]++;
    
    // Warn if component renders too often
    if (this.renderCounts[componentName] > 10) {
      console.warn(`⚠️ Component "${componentName}" rendered ${this.renderCounts[componentName]} times in the last period`);
    }
  }
  
  trackApiCall(endpoint) {
    if (!DEBUG) return;
    
    if (!this.apiCalls[endpoint]) {
      this.apiCalls[endpoint] = 0;
    }
    this.apiCalls[endpoint]++;
    
    // Warn if API called too often
    if (this.apiCalls[endpoint] > 5) {
      console.warn(`⚠️ API endpoint "${endpoint}" called ${this.apiCalls[endpoint]} times in the last period`);
    }
  }
  
  logSummary() {
    if (!DEBUG) return;
    
    const hasActivity = Object.keys(this.renderCounts).length > 0 || Object.keys(this.apiCalls).length > 0;
    
    if (hasActivity) {
      console.group('📊 Debug Summary (last 30s)');
      
      if (Object.keys(this.renderCounts).length > 0) {
        console.log('Component Renders:', this.renderCounts);
      }
      
      if (Object.keys(this.apiCalls).length > 0) {
        console.log('API Calls:', this.apiCalls);
      }
      
      console.groupEnd();
    }
  }
}

export const debugLogger = new DebugLogger();